<template>
  <div id="exhibitionService">
    <div class="title"><span>会展服务</span></div>
    <el-carousel
      indicator-position="outside"
      type="card"
      ref="myCarousel"
      id="myCarousel"
      :interval="4000"
      height="240px"
      @change="change"
    >
      <el-carousel-item v-for="item in list" :key="item">
        <img class="item-img" :src="item" />
      </el-carousel-item>
      <div class="content-box">
        <h5>{{ currItem.title }}</h5>
        <!-- <p>{{ currItem.content }}</p> -->
      </div>
    </el-carousel>
  </div>
</template>

<script>
import { exhibitionService } from "@/core/util";
export default {
  data() {
    return {
      list: [
        "/serviceimg/1.jpg",
        "/serviceimg/2.jpg",
        "/serviceimg/3.jpg",
        "/serviceimg/4.jpg",
        "/serviceimg/5.jpg",
        "/serviceimg/6.jpg",
        "/serviceimg/7.jpg",
        "/serviceimg/8.jpg",
        "/serviceimg/9.jpg",
        "/serviceimg/10.jpg",
        "/serviceimg/11.jpg",
        "/serviceimg/12.jpg",
        "/serviceimg/13.jpg",
        "/serviceimg/14.jpg",
        "/serviceimg/15.jpg",
        "/serviceimg/16.jpg",
        "/serviceimg/17.jpg",
        "/serviceimg/18.jpg",
        "/serviceimg/19.jpg",
        "/serviceimg/20.jpg",
        "/serviceimg/21.jpg",
        "/serviceimg/22.jpg",
        "/serviceimg/23.jpg",
        "/serviceimg/24.jpg",
        "/serviceimg/25.jpg",
        "/serviceimg/26.jpg",
        "/serviceimg/27.jpg",
        "/serviceimg/28.jpg",
        "/serviceimg/29.jpg",
        "/serviceimg/30.jpg",
        "/serviceimg/31.jpg",
        "/serviceimg/32.jpg",
        "/serviceimg/33.jpg",
        "/serviceimg/34.jpg",
        "/serviceimg/35.jpg",
        "/serviceimg/img_1.png",
        "/serviceimg/img_2.png",
        "/serviceimg/img_3.png",
        "/serviceimg/img_4.png",
        "/serviceimg/img_5.png",
        "/serviceimg/img_6.png",
      ],
      currItem: exhibitionService[0],
    };
  },
  mounted() {
    const myCarousel = document.getElementById("myCarousel");
    myCarousel.addEventListener("touchstart", (e) => {
      this.thetouchstart(e);
    });

    myCarousel.addEventListener("touchend", (e) => {
      this.thetouchend(e);
    });
  },
  methods: {
    change(index) {
      this.currItem = exhibitionService[index];
    },
    thetouchstart(e) {
      this.theTouch = e.touches[0].pageX; //保存开始滑动的点
    },
    thetouchend(e) {
      if (e.changedTouches[0].pageX > this.theTouch) {
        //判断手指是向左还是向右滑动
        this.$refs.myCarousel.prev();
      } else {
        this.$refs.myCarousel.next();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#exhibitionService {
  background-image: url("../../assets/images/bg_2.png");
  .content-box {
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    position: absolute;
    top: 150px;
    padding: 0 16px;
    h5 {
      margin-bottom: 10px;
      font-size: 16px;
    }
  }
  .title {
    display: flex;
    align-items: center;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: 18px;
    color: #fff;
    position: relative;
    padding-top: 30px;
    margin: 0 16px 50px 16px;
    span {
      position: absolute;
      z-index: 2;
    }
  }

  .title::before {
    content: "";
    width: 86px;
    height: 3px;
    background: #fff;
    position: absolute;
    top: 54px;
  }
  /deep/.el-carousel__indicators--outside {
    display: none;
  }
  /deep/.el-carousel__container {
    height: 128px;
  }

  /deep/.el-carousel__arrow {
    display: none;
  }
  /deep/.el-carousel__button {
    width: 6px;
    height: 6px;
    background: #fff;
    border-radius: 100%;
  }
  /deep/.el-carousel__indicator.is-active button {
    background: #0068b7;
    border-radius: 33px 33px 33px 33px;
    width: 23px;
    height: 6px;
  }
  /deep/.el-carousel__item,
  .el-carousel__mask {
    height: 128px;
  }
  .titles {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }
  .item-img {
    width: 187px;
    height: 125px;
    background: #ffffff;
  }
  .project-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .project-item {
    width: 164px;
    display: flex;
    flex-direction: column;
    img {
      width: 164px;
      height: 120px;
      box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.25);
    }
    span {
      font-weight: 400;
      font-size: 16px;
      color: #666666;
      margin: 14px 0;
    }
  }
}
</style>